import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskCompanySize({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();

  const [memberCount, setMemberCount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      setMemberCount(loggedInUser.memberCount);
    }
  }, []);

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Company Size"
      skipID={"companyStatOnboardingSkipped"}
      title={"Tell us about your scale"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          label={"Number Of Employees"}
          value={memberCount}
          onChange={extractEventValue(setMemberCount)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { memberCount },
      });

      setLoading(false);

      let newLoggedInUser = {
        ...loggedInUser,
        memberCount,
      };

      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
